import { useCallback } from 'react';
import { triggerAnalyticsCustomEvent } from '../utils/analyticsEvents';

const useFormSubmit = ({ mountedRef, setShowSuccessAlert, setShareModalOpen }) => {
  return useCallback((values, { setSubmitting }) => {
    if (!mountedRef.current) return;

    try {
      const validEmails = values.emails.filter((email) => email.trim() !== '');
      // eslint-disable-next-line no-console
      console.log('Form submitted with values:', { ...values, emails: validEmails });
      triggerAnalyticsCustomEvent('quotes.share-submit', {
        settings: values.options,
      });

      setSubmitting(false);

      setTimeout(() => {
        if (mountedRef.current) {
          setShowSuccessAlert(true);
          setShareModalOpen(false);
        }
      }, 100);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Form submission error:', error);
      if (mountedRef.current) {
        setSubmitting(false);
      }
    }
  }, [mountedRef, setShowSuccessAlert, setShareModalOpen]);
};

export default useFormSubmit;
